
export const  filterQuery = (val: any) => {
  const parameterizeArray = (key:any, arr:any) => {
    arr = arr.map(encodeURIComponent)
    return key+'[]=' + arr.join('&'+key+'[]=')
  }

  let query:string=''
  val.map((element:any)=>{

    // поисковая строка

    if(element.type === "search"){
      if (element.value.length){
        query +=`searchStr=${element.value}&`
      }

    }
    //Архивные записи
    if(element.type === "isArchiveFilter" && element.value.length >0){
      if(element.value[0].id !== 'all'){
        if(element.value[0].id == '1'){
          query +=`isArchived=false&`
        } else {
          query +=`isArchived=true&`
        }
      }
    }

    //Анкеты
    if (element.type === "surveyFilter" && element.value.length>0) {
      if(element.value[0].id !== 'all'){
        query +=`${parameterizeArray('surveyIds', element.value.map((el:any)=>{return el.id}))}&`
      }
    }

    //Опции таблицы
    if (element.type === "options") {
      for (let key in element.value) {
        if(key=='page'){
          query +=`page=${element.value.page}&`
        }
        if(key=='itemsPerPage'){
          query +=`per-page=${element.value.itemsPerPage}&`
        }
        if(key=='sortBy'){
          // console.log(element.value.sortDesc[0]);
          if(element.value.sortBy.length !==0 && element.value.sortDesc[0] == true ){
            query +=`sort=${element.value.sortBy[0]}&`
          }else {
            if(element.value.sortBy.length !==0) query +=`sort=-${element.value.sortBy[0]}&`

          }
        }
      }
    }

    //Даты
    if (element.type === "datePickerFilter" && element.value.length>0) {
      console.log(element)
      if(element.value[0].id !== 'all'){
        if(element.value.length === 1){

          const start = new Date(Date.parse(element.value[0])).setHours(0,0,1)
          const finish = new Date(Date.parse(element.value[0])).setHours(23,59,59,999)

          const startTS = new Date(start/1000).getTime()
          const finishTS = new Date(finish/1000).getTime()


          query +=`beginCreatedAtTimestamp=${startTS}&`
          query +=`endCreatedAtTimestamp=${finishTS}&`
        } else {
          query +=`beginCreatedAtTimestamp=${Date.parse(element.value[0])/1000}&`
          query +=`endCreatedAtTimestamp=${Date.parse(element.value[1])/1000}&`
        }
      }
    }


    // Заметки Да/Нет
    if(element.type === "notesFilter" && element.value.length>0){
      if(element.value[0].id !== 'all'){
        if(element.value[0].id == '1'){
          query +=`hasMediaAttachments=true&`
        } else {
          query +=`hasMediaAttachments=false&`
        }
      }
    }

    //Выбор стендистов
    if(element.type === "typeFilterFio" && element.value.length){
      if(element.value[0].id !== 'all'){
        query +=`${parameterizeArray('standmanIds', element.value.map((el:any)=>{return el.id}))}&`
      }
    }

    //Выбор категории (новый, существующий, не указан)
    if(element.type === "categoryFilter" && element.value.length){
      if(element.value[0].id !== 'all'){
        query +=`${parameterizeArray('categories', element.value.map((el:any)=>{return el.value}))}&`

      }
    }
    //Выбор заинтересованности (холодный, теплый , горячий)
    if(element.type === "hotLevelFilter" && element.value.length){
      if(element.value[0].id !== 'all'){
        query +=`${parameterizeArray('hotLevels', element.value.map((el:any)=>{return el.value}))}&`
      }
    }
    //Выбор типу контака (компания, продукт, контакт)
    if(element.type === "typeContact" && element.value.length){
      if(element.value[0].id !== 'all'){
        query +=`${parameterizeArray('shardTypes', element.value.map((el:any)=>{return el.value}))}&`
      }
    }

  })
  return query
}
